import defaultOgImageJpg from '../../assets/og-image.jpg';
import { canonical, description, join, meta, openGraph, title } from '@rea-argonaut/actions';
import { isNotNullOrUndefinedValue } from '../../helpers/isNotNullOrUndefinedValue';
import { Head } from './types';
import { getSeoSchema } from '../helpers/getSeoSchema';
import { getResourceHints } from '../helpers/getResourceHints';

export const getHead = (head: Head | null, allowIndexing: boolean) => {
  const { url: ogImageUrl = defaultOgImageJpg, ...ogImageFields } = head?.ogImage || {};
  return join(
    ...[
      head?.title && title(head?.title),
      head?.description && description(head?.description),
      head?.canonical && canonical(head?.canonical),
      openGraph({
        property: 'og:locale',
        content: 'en_AU',
      }),
      openGraph({
        property: 'og:type',
        content: 'website',
      }),
      head?.title &&
        openGraph({
          property: 'og:title',
          content: head?.title,
        }),
      head?.description &&
        openGraph({
          property: 'og:description',
          content: head?.description,
        }),
      head?.canonical &&
        openGraph({
          property: 'og:url',
          content: head?.canonical,
        }),
      head?.siteName &&
        openGraph({
          property: 'og:site_name',
          content: head?.siteName,
        }),
      openGraph({
        property: 'og:image',
        content: ogImageUrl,
      }),
      ...Object.entries(ogImageFields).map(
        ([key, value]) =>
          value &&
          openGraph({
            property: `og:image:${key}`,
            content: value,
          }),
      ),
      meta({
        name: 'thumbnail',
        content: ogImageUrl,
      }),
      meta({
        name: 'robots',
        content: allowIndexing
          ? 'index, follow, noodp'
          : 'noindex, nofollow, noodp, noarchive, nositelinkssearchbox, nosnippet, noimageindex',
      }),
      ...getSeoSchema(head?.seoSchemas),
      ...getResourceHints(head?.resourceHints),
    ].filter(isNotNullOrUndefinedValue),
  );
};
